<adm-type-ahead-selector2
  label="Vælg tværgående rabat"
  [fetchFn]="fetchDiscounts"
  [fetchByIdFn]="fetchDiscountById"
  [initialId]="initialId()?.toString()"
  (itemSelected)="discountSelected($event)"
  identityPropertyName="identifier"
  (clearTypeAhead)="clearTypeAhead.emit()"
  [resetTrigger]="resetTrigger()"></adm-type-ahead-selector2>
